import { Accordion, AccordionItem } from "@heroui/accordion";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useApproveDeclineCommitteeMutation,
  useGetSingleCommitteQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import bull from "../../../../assets/bull.png";
import flag from "../../../../assets/finish-FLAG.png";
import person from "../../../../assets/personAppraisal.png";
import PageStyle from "../../../../Components/Layout/PageLayout";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import ApproveModal from "../Modals/ApproveModal";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";

const CommitteeListView = () => {
  const { id } = useParams();
  const { data } = useGetSingleCommitteQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] = useApproveDeclineCommitteeMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const declineVariable = 1;
  const approveVaiable = 0;
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === 1) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        id,
        comments: comment,
        decision: type,
        committeeId: parseInt(id),
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/hr/HR-Appraisal-Setup/Committee-List");
      }
    } catch (error) {
      toast.error(
        error?.data?.statusMessage ?? "Error approving Appraisal Objectives"
      );
      console.log(error);
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const formMethods = useForm({
    mode: "all",
  });
  // const { handleSubmit } = formMethods;
  return (
    <div>
      <PageStyle
        action={null}
        hasBack={true}
        backURL={"/dashboard/hr/HR-Appraisal-Setup/Committee-List"}
        hasTopPageDemo
        demoTitle={"Committee List Review"}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="w-3" />
          <div className={DashboardStyle.button_cage}>
            <button
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              onClick={handleApproveModal}
              type="button"
            >
              Approve
            </button>
            <ActionButtons
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              style={{ backgroundColor: "red" }}
              onClick={handleDeclineModal}
              type="button"
            >
              Decline
            </ActionButtons>
          </div>
        </div>
        <FormProvider {...formMethods}>
          <form id="selfAssessmentForm">
            <div className="flex items-center justify-between mb-4">
              <div className="w-[30px]" />
              <div>
                <p className="text-[#00AB09]">
                  {/* Total Actual Score: {totalActualScore} */}
                </p>
              </div>
            </div>
            <div className="mb-4"></div>
            <Accordion
              aria-label={`Accordion 1`}
              selectionMode="single"
              defaultExpandedKeys={["1"]}
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                title={
                  <div className="flex items-center gap-5 px-5">
                    <img src={person || "/placeholder.svg"} alt="" />{" "}
                    <span className="text-[#305F32] font-[600]">
                      COMMITTEE SUMMARY
                    </span>
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <div className="px-5 py-4">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(32.3%, 1fr))",
                      gap: "16px",
                    }}
                  >
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Title:
                      </p>
                      <h4 className="text-[#4B664C] font-[500] text-base">
                        {data?.responseObject?.title || "Not available"}
                      </h4>
                    </div>
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Description:
                      </p>
                      <h4 className="text-[#4B664C] font-[500] text-base">
                        {data?.responseObject?.description || "Not available"}
                      </h4>
                    </div>
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Committee Head Name:
                      </p>
                      <h4 className="text-[#4B664C] font-[500] text-base">
                        {data?.responseObject?.committeeHeadName ||
                          "Not available"}
                      </h4>
                    </div>
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Department Name:
                      </p>
                      <h4 className="text-[#4B664C] font-[500] text-base">
                        {data?.responseObject?.departmentName ||
                          "Not available"}
                      </h4>
                    </div>
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Approval Status:
                      </p>
                      <h4 className="text-[#4B664C] font-[500] text-base">
                        {typeof data?.responseObject?.approvalStatus ===
                        "number"
                          ? getStatusText(data?.responseObject?.approvalStatus)
                          : data?.responseObject?.approvalStatus}
                      </h4>
                    </div>
                    <div className="mb-3">
                      <p className="text-[#305F32] font-[600] text-sm mb-1">
                        Members:
                      </p>
                      {data?.responseObject?.members?.map((item) => (
                        <div key={item?.id} className=" space-y-2">
                          <p className="text-[#4B664C] font-[500] text-base">
                            Name: <span>{item?.employeeName}</span> <br />
                          </p>
                          <p className="text-[#4B664C] !mt-0 text-[12px]">
                            Department: <span>{item?.departmentName}</span>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>

            <Accordion
              aria-label={`Accordion main`}
              selectionMode="single"
              defaultExpandedKeys={["1"]}
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                title={
                  <div className="flex items-center justify-between px-5">
                    <div className="flex items-center gap-5">
                      <img src={flag || "/placeholder.svg"} alt="" />
                      <span className="text-[#4B664C] font-[600]">
                        OBJECTIVE:{" "}
                        {data?.responseObject?.krAs[0]?.objectiveTitle}
                      </span>
                    </div>
                    <div>
                      <span className="text-[#4B664C] font-[600]">
                        Weight: {data?.responseObject?.krAs[0]?.weight}%
                      </span>
                    </div>
                    <div className="w-10" />
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <div>
                  {data?.responseObject?.krAs.map((items, kraIndex) => (
                    <Accordion
                      key={kraIndex + 1}
                      aria-label={`Accordion ${kraIndex + 1}`}
                      selectionMode="single"
                      defaultExpandedKeys={["1"]}
                      titleWrapper="shadow-md rounded-md border border-gray-200"
                    >
                      <AccordionItem
                        key={kraIndex + 1}
                        title={
                          <div className="flex items-center gap-5 px-5">
                            <img src={bull || "/placeholder.svg"} alt="" />
                            <span className="text-[#4B664C] font-[600]">
                              KRA: {items?.title}
                            </span>
                          </div>
                        }
                        className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                      >
                        <div>
                          {items.isAutoGenerated && (
                            <div className="flex items-center justify-between px-5">
                              <div />
                              <div>
                                <p className="text-[#4B664C] font-[600]">
                                  isAutogenerated
                                </p>
                              </div>
                            </div>
                          )}
                          <div
                            key={kraIndex + 1}
                            className="flex items-center gap-5 py-2 px-5"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "180px 1fr",
                              alignItems: "center",
                              gap: "16px",
                            }}
                          >
                            <h2 className="text-[#305F32] font-[600]">
                              Title: {items.keyResultTitle}
                            </h2>
                            <h4 className="text-[#305F32] font-[500]">
                              Description: {items.keyResultDescription}
                            </h4>
                            <h2 className="text-[#305F32] font-[600]">
                              Target: {items.targetValue}
                            </h2>
                            <h4 className="text-[#00AB09] font-[500]">
                              Score: {items.threshold || "N/A"}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Measurement Type: {items.measurementType}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Period Start Date:
                              {FormatDateTime(
                                items.periodStartDate,
                                "DD/MM/YYYY"
                              )}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Period End Date:
                              {FormatDateTime(
                                items.periodEndDate,
                                "DD/MM/YYYY"
                              )}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Next Due Date:
                              {FormatDateTime(items.nextDueDate, "DD/MM/YYYY")}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Self Appraisal Hours: {items.selfAppraisalHours}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Reviewer Hours: {items.reviewerHours}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Reminder Count: {items.reminderCount}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Approal Status:
                              {typeof items.approvalStatus === "number"
                                ? getStatusText(items.approvalStatus)
                                : items.approvalStatus}
                            </h4>
                          </div>
                        </div>
                      </AccordionItem>
                    </Accordion>
                  ))}
                </div>
              </AccordionItem>
            </Accordion>
          </form>
        </FormProvider>
      </PageStyle>
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() => declineAction(declineVariable)}
          isLoading={isLoading}
          disabled={!comment}
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(approveVaiable)}
        handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Committee List"}
      />
    </div>
  );
};

export default CommitteeListView;
